<script>
import axios from "axios"
import ExtendedSearch from "@/components/search/search-devices.vue"

export default {
  name: "DeviceSearch",
  components: {
    "extended-search": ExtendedSearch,
  },
  emits: ["search", "allProjects", "setFilterData"],
  props: {
    technology: {
      type: String,
      required: true,
    },
    updateResponsiveTable: {
      type: Function,
      required: true,
    },
    reloadItems: {
      type: Function,
      required: true,
    },
    projectId: {
      type: String,
      required: true,
    },
    filterType: {
      type: Array,
      required: false,
    },
  },
  data: () => ({
    isSearchThroughAllProjects: false,
    search: "",
    suggested: "",
    suggestionsArray: [],
    extendedSearchOpen: false,
  }),
  computed: {
    fullTextSearch() {
      const substrings = this.search.split("-")
      if (substrings.filter((str) => str.length).length > 1) {
        const transformedSubstrings = []
        for (const substring of substrings) {
          if (substring.length <= 2) {
            continue
          }

          transformedSubstrings.push(`+${substring}`)
        }

        return transformedSubstrings.join(" ")
      }
      return this.search.replace("-", "")
    },
  },
  watch: {
    search() {
      this.$emit("search", this.fullTextSearch)
      if (this.suggested == "") {
        if (this.search.length > 1) {
          this.suggestions()
        }
      } else {
        this.suggested = ""
      }
    },
    isSearchThroughAllProjects() {
      this.$emit("allProjects", this.isSearchThroughAllProjects)
    },
  },
  methods: {
    searchDevices() {
      this.loadingData = true
      this.suggestionsArray = []
      this.page = 0
      if (this.search.length < 1) {
        this.isSearchThroughAllProjects = false
      }
      this.reloadItems()
      window.addEventListener("resize", this.updateResponsiveTable)
      window.addEventListener("click", this.updateResponsiveTable)
    },
    clearSearch() {
      this.search = ""
      this.$emit("search", this.search)
      this.suggested = ""
      this.isSearchThroughAllProjects = false
      this.searchDevices()
      this.suggestionsArray = []
    },
    setSuggestion(suggestion) {
      this.suggested = suggestion
      this.search = suggestion
      this.$emit("search", this.search)
      this.searchDevices()
      this.suggestionsArray = []
    },
    suggestions() {
      let url = ""
      if (this.isSearchThroughAllProjects) {
        url = `${process.env.VUE_APP_API}/${
          this.technology
        }/devices/suggestions?search=${encodeURIComponent(
          this.fullTextSearch
        )}*`
      } else {
        url = `${process.env.VUE_APP_API}/${
          this.technology
        }/devices/suggestions?projectId[eq]=${
          this.projectId
        }&search=${encodeURIComponent(this.fullTextSearch)}*`
      }

      axios.get(url, {}).then((response) => {
        this.suggestionsArray = response.data.data
      })
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex list-page__left align-items-center w-100">
      <div
        class="custom-control custom-control--search d-flex align-items-center justify-content-between list-page__search"
      >
        <input
          id="guisearch"
          ref="searchInput"
          v-model="search"
          type="text"
          class="w-100"
          :placeholder="this.$t('Hledat podle názvu, ID, tagu, …')"
          autofocus
          @keyup.enter="searchDevices()"
        />

        <div v-if="search" class="atom-icon" @click="clearSearch()">
          <img src="@/assets/icons/actions/ico-close.svg" />
        </div>
        <div class="atom-icon" @click="searchDevices()">
          <img src="@/assets/icons/actions/ico-search-black.svg" />
        </div>
        <div class="custom-control--search__suggestions">
          <div
            v-for="(suggestion, index) in suggestionsArray"
            :key="index"
            class="custom-control--search__suggestions__item"
            @click="setSuggestion(suggestion)"
          >
            <span>{{ suggestion }}</span>
          </div>
        </div>
      </div>
      <div
        class="list-page__link d-none d-lg-flex"
        style="flex-shrink: 0; height: fit-content"
      >
        <a
          :class="{ open: this.extendedSearchOpen }"
          class="h-fit d-flex align-items-center extended-search__toggle"
          @click="extendedSearchOpen = !extendedSearchOpen"
        >
          {{ $t("pokrocilaFiltrace") }}
          <img src="@/assets/icons/arrows/arr-orange-down.svg" class="" />
        </a>
      </div>
    </div>
    <extended-search
      class="w-100"
      v-if="extendedSearchOpen"
      :filterType="filterType"
      @setFilterData="$emit('setFilterData', $event)"
      @close="extendedSearchOpen = false"
    />
    <div class="mt-4">
      <div class="d-lg-flex">
        <div
          style="display: inline-block"
          class="custom-control custom-control--checkbox"
          :class="{ checked: isSearchThroughAllProjects }"
          @click="isSearchThroughAllProjects = !isSearchThroughAllProjects"
        >
          <input type="checkbox" class="custom-control-input" />
        </div>
        <label>{{ $t("SEARCH_THROUGH_ALL_PROJECTS") }}</label>
      </div>
    </div>
  </div>
</template>

<style>
.extended-search__toggle.open img {
  transform: rotate(-180deg);
}
</style>
